import { EffectCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { ERequestStatus } from '../../types/requestStatus';
import { useCurrentListingStatus } from '../useCurrentListingStatus';
import { selectListingAppendType } from '../../selectors/settings/selectListingAppendType';
import { IApplicationState } from '../../types/redux';
import { useQueryStringKey } from '../useQueryStringKey';
import { selectCurrentPageMeta } from '../../selectors/pagesMeta';
import { setListingAppendType } from '../../actions/settings';

/**
 * Выполняет callback для запроса листинга
 */
export const useGetListing = (callback: EffectCallback) => {
  const dispatch = useDispatch();
  const listingStatus = useCurrentListingStatus();
  const { pathname } = useLocation();
  const { rubricId, category } = useSelector((state: IApplicationState) => selectCurrentPageMeta(state, pathname));
  const appendType = useSelector(selectListingAppendType);
  const key = useQueryStringKey({ rubricId, category: category || '' });
  const [prevKey, setPrevKey] = useState(key);

  /**
   * Запускает callback, если хотя бы соблюдено одно из условий:
   * - список находится в статусе инициализации
   * - слепок значений из чувствительных ключей изменился
   */
  useEffect(() => {
    if (listingStatus !== ERequestStatus.Initial && key === prevKey) {
      return;
    }

    callback();
    setPrevKey(key);
  }, [callback, key, listingStatus, prevKey]);

  /**
   * Скролим наверх пока идет загрузка
   * (не для режима подгрузки)
   */
  useEffect(() => {
    if (listingStatus !== ERequestStatus.Loading) {
      return;
    }

    if (appendType === 'set') {
      window.scrollTo(0, 0);
    }
  }, [appendType, listingStatus]);

  /**
   * Сбрасываем тип сохранения материалов на дефолтный
   * в любом конечном статусе запроса
   */
  useEffect(() => {
    if (listingStatus === ERequestStatus.Loading) {
      return;
    }

    dispatch(setListingAppendType('set'));
  }, [dispatch, listingStatus]);
};
